import { v4 as uuidv4 } from "uuid";

/**
 * The analytics session covers a single page lifetime. The session id itself is
 * never persisted — no localStorage or sessionStorage — so a reload always
 * starts a new session. That is deliberate: it lets the embedded device tell a
 * clean session end (a report with `final: true`) apart from a reload or a
 * crash (a session whose reports simply stop).
 */
export const SESSION_ID = uuidv4().replace(/-/gi, "");

export const SESSION_START = new Date();

export const sessionDurationSeconds = () =>
  Math.max(0, Math.round((Date.now() - SESSION_START.getTime()) / 1000));
